export enum HttpMethod {
	Post = 'POST',
	Get = 'GET',
	Patch = 'PATCH',
	Put = 'PUT',
	Delete = 'DELETE',
	Options = 'OPTIONS',
}